<template>
    <div class="container select-case-container">
        <breadcrumb :to="breadcrumbTo" :useOffset="false"></breadcrumb>
        <h1>{{ themeTitle }}</h1>
        <transition mode="out-in" name="fade">
            <div class="transition-root" key="loadingCases" v-if="loading">
                <div class="row">
                    <loading-indicator>Henter cases..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="loadingCase" v-if="loadingCase">
                <div class="row">
                    <loading-indicator>Henter case info..</loading-indicator>
                </div>
            </div>
            <div class="transition-root" key="notLoading" v-if="!loading && !loadingCase">
                <div class="row">
                    <content-card
                            class="col-sm"
                            v-bind:key="i"
                            v-bind:media="card.picture"
                            v-bind:title="card.title"
                            v-for="(card, i) in caseCards"
                            v-on:onClick="onSelectCase(card)"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import ContentCard from '@/components/content-card'
    import Breadcrumb from '@/components/breadcrumb'
    import LoadingIndicator from '@/components/loading-indicator'
    import * as MutationTypes from '@/store/mutation-types'
    import AppConfig from '@/app-config'
    import {getTeacherUrl} from '@/utils/UrlUtil'
    import GamePhase from '@/enum/GamePhase'

    export default {
        components: {
            ContentCard,
            Breadcrumb,
            LoadingIndicator
        },
        data() {
            return {
                loadingCase: false,
                loading: true,
                caseCards: [],
                currentTheme: this.$store.getters.getCurrentTheme
            }
        },
        mounted() {
            if (!this.currentTheme) {
                console.log('Current theme missing - going back to index')

                this.$router.push(getTeacherUrl('select-theme'))

                return
            }

            this.$gameClient.send({
                _selectedCaseId: -1,
                _phase: GamePhase.SelectCase
            });

            let gameType = 'classRoom';

            this.$apiClient.getThemeCasesFromRoomId(this.$gameClient.roomId, this.currentTheme.id, gameType, (cases) => {
                this.caseCards = cases
                this.loading = false

                if (AppConfig.autoCaseSelection) {
                    for (let _case of cases) {
                        if (_case.id === AppConfig.autoCaseSelection) {
                            this.onSelectCase(_case)
                        }
                    }
                }
            })

            this.$store.commit(MutationTypes.SET_CURRENT_CASE, null)
        },
        methods: {
            onSelectCase(_case) {
                let caseId = _case.id
                let themeId = this.$store.getters.getCurrentTheme.id

                this.$apiClient.getCase(themeId, caseId, (_case) => {
                    this.$store.commit(MutationTypes.SET_CURRENT_CASE, _case)

                    this.loadingCase = false;

                    this.$gameClient.send({
                        _selectedCaseId: caseId,
                        _phase: GamePhase.Lobby
                    });
                })
            }
        },
        computed: {
            themeTitle() {
                return this.currentTheme ? this.currentTheme.title : ''
            },
            breadcrumbTo() {
                return getTeacherUrl('select-theme');
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @import "~@less/variables.less";

    .select-case-container {
        margin-top: @breadcrumb-offset;
    }
</style>
